export const initialValues = {
  benefitsSectionSubtitle:
    "Choosing an in-home care provider is a significant decision. Here's why families trust Home Instead:",
  benefitsSectionTitle: "Why choose Home Instead?",
  consultationButtonText: "Learn More",
  consultationSectionSubtitle:
    "We understand every family's situation is unique. That's why we offer a free in-home consultation to assess your needs and recommend a care plan that's right for you.",
  consultationSectionTitle: "The Benefits of In-Home Care",
  description: "Trusted in-home care for aging adults",
  pageURL: "care.homeinstead.com/ppc/trusted-home-care",
  subtitle: "Start finding in-home care near you in as little as 3 minutes.",
  testimonialsSectionTitle: "Hear from our customers",
  title: "Trusted In-Home Care for Older Adults",
} as const;
